import React from "react";
import { useIntl } from "react-intl";
import IconButton from "./IconButton";
export default function AddButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("p", {
    className: "col-xs-3 col-xs-offset-9 text-right ".concat(className)
  }, /*#__PURE__*/React.createElement(IconButton, {
    type: "info",
    icon: "plus",
    className: "btn-add col-xs-12",
    "aria-label": useIntl().formatMessage({
      id: "2/2yg+",
      defaultMessage: [{
        "type": 0,
        "value": "Add"
      }]
    }),
    tabIndex: "0",
    onClick: onClick,
    disabled: disabled
  })));
}